import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import HeaderWithTag from "../../common/header_with_tag";
import { IGetExchangeRatesRequest } from "../../types/types";
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";
import TryGetExchangeRates from "./try";

const requestCode: IGetExchangeRatesRequest = {
  currency: "KES"
};

const requestExample = `GET ${HOST_API_URL}/Remittances/GetExchangeRates?currency=KES
Authorization: Bearer <token>`;

const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": {
    "currency": "KES",
    "sellingRate": "129.5000",
    "buyingRate": "128.7500"
  }
}`;

const failureResponseCode = `{
  "statusCode": 400,
  "message": "Currency rates not found",
  "errorCode": "DPI-3006",
  "data": null
}`;

function GetExchangeRates() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Get Exchange Rates</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Get Exchange Rates
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Retrieve exchange rates"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          GET
                        </span>
                        {HOST_API_URL}/Remittances/GetExchangeRates?currency={"{currency}"}
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Returns the most recently published general buying and selling rates
                        for the specified currency. Use this to display rates to users before
                        initiating transactions.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Query Parameters"
                          headerTag="request"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameter</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Required</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>currency</td>
                                <td>string</td>
                                <td>Currency code (e.g. KES). An unknown code returns DPI-3006.</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted text-14 mb-0">
                          Omitting <code>currency</code>, or sending it empty, returns 400 with
                          DPI-1000.
                        </p>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={requestExample}
                          codeBlackText="Request"
                          codeLanguage="http"
                        />
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>statusCode</td>
                                <td>integer</td>
                                <td>200 on success, otherwise the failure status</td>
                              </tr>
                              <tr>
                                <td>message</td>
                                <td>string</td>
                                <td>"Success", or the reason for the failure</td>
                              </tr>
                              <tr>
                                <td>errorCode</td>
                                <td>string</td>
                                <td>null on success; a stable DPI-xxxx code on failure</td>
                              </tr>
                              <tr>
                                <td>data.currency</td>
                                <td>string</td>
                                <td>Echoes the currency value you sent</td>
                              </tr>
                              <tr>
                                <td>data.sellingRate</td>
                                <td>string</td>
                                <td>Selling rate for the currency</td>
                              </tr>
                              <tr>
                                <td>data.buyingRate</td>
                                <td>string</td>
                                <td>Buying rate for the currency</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Example"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={failureResponseCode}
                          codeBlackText="Failure Example"
                          codeLanguage="json"
                        />
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                    Code Samples
                  </h5>

                  <TryGetExchangeRates
                    codeBlackTitle="Request Example"
                    getExchangeRatesObject={requestCode}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetExchangeRates;